import React, { Component } from 'react';
import { connect } from 'react-redux';
import classnames from 'classnames';
import {
    resetActiveFeature,
    resetFeatureMap,
    setActiveFeature,
    setFeatureIndicator
} from '../actions';
import RightArrow from "./right-arrow";
import * as ReactGA from 'react-ga';

class AccordionItem extends Component {

    constructor(props) {
        super(props);

        this._toggleFeature = this._toggleFeature.bind(this);
        this._setIndicator = this._setIndicator.bind(this);
    }

    _toggleFeature() {
        const { featureKey, activeFeature, openFeature, closeFeatures, item } = this.props;

        if( featureKey === activeFeature ){
            closeFeatures();
        }else{
            openFeature( featureKey );
            ReactGA.event({
               category: 'Bacteria',
               action: 'Annotation Expanded',
               label: item.title
            });
        }
    }

    _setIndicator( reference, title ) {
        const { setIndicator, activeFeature, featureKey } = this.props;

        if( featureKey === activeFeature ){
            setIndicator( reference, title );
        }
    }

    render() {
        const { item, featureKey, activeFeature } = this.props;

        const titleClasses = classnames(
            'accordion-title',
            {'accordion-title-open': featureKey === activeFeature}
        );
        const contentClasses = classnames(
            'accordion-content',
            {'accordion-content-open': featureKey === activeFeature}
        );

        let content = '<p>' + item.content + '</p>';
        if( item.credit !== null ){
            content += '<p><em>';
            if( item.image !== null ){
                content += 'Image Credit: ';
            }else if( item.video !== null ){
                content += 'Video Credit: ';
            }
            content += item.credit;
            content += '</em></p>'
        }

        return(
            <div className="accordion-item">
                <div className={titleClasses} onClick={ this._toggleFeature }>
                    <div className="accordion-indicator" key={ item.title } ref={ ( indicator ) => { this._setIndicator( indicator, item.title ); } } />
                    <h3><span dangerouslySetInnerHTML={ {__html: item.title} } /> <RightArrow /></h3>
                </div>
                <div className={contentClasses} dangerouslySetInnerHTML={ { __html: content } } />
            </div>
        );
    }

}

const mapStateToProps = ( state ) => {
    return {
        activeFeature: state.activeFeature
    };
};

const mapDispatchToProps = ( dispatch ) => {
    return{
        openFeature: ( featureKey ) => {
            dispatch( resetFeatureMap() );
            dispatch( setActiveFeature( featureKey ) );
        },
        closeFeatures: () => {
            dispatch( resetActiveFeature() );
            dispatch( resetFeatureMap() );
        },
        setIndicator: ( indicatorRef, title ) => {
            dispatch( setFeatureIndicator( indicatorRef, title ) );
        }
    };
};

export default connect(mapStateToProps,mapDispatchToProps)(AccordionItem);



// WEBPACK FOOTER //
// ./src/components/accordion-item.js